import { EVENTS } from "../events/botContants";

export const createCloseChatActivity = (userId) => ({
  from: { id: userId, name: "user" },
  type: "event",
  name: EVENTS.CLOSE_CHAT_WINDOW,
  text: "[closed_chat_window]",
  textFormat: "plain",
  value: EVENTS.CLOSE_CHAT_WINDOW,
});

export const resolveBotCloseChatOptions = (activity, pendingOptions) => {
  const isBotCloseEvent =
    activity?.type === "event" &&
    activity?.value === EVENTS.CLOSE_CHAT_WINDOW &&
    activity?.from?.role === "bot";

  return isBotCloseEvent ? { ...(pendingOptions ?? {}) } : null;
};

const resolveLatestString = (getter, fallback, errorMessage) => {
  try {
    if (typeof getter === "function") {
      const value = getter();
      return typeof value === "string" ? value : fallback;
    }
  } catch (error) {
    console.error(errorMessage, error);
  }

  return fallback;
};

export const completeChatClose = ({
  closeNative,
  emitEvent,
  getSessionId,
  getSurveyURL,
  redirectUrl = "",
  sessionId = "",
  surveyURL = "",
}) => {
  const latestSessionId = resolveLatestString(
    getSessionId,
    sessionId,
    "Unable to read latest session ID.",
  );
  const latestSurveyURL = resolveLatestString(
    getSurveyURL,
    surveyURL,
    "Unable to read latest survey URL.",
  );

  const deliveryResult = (() => {
    try {
      return typeof emitEvent === "function"
        ? emitEvent({
            type: EVENTS.CHAT_CLOSED,
            payload: {
              sessionKey: latestSessionId,
              surveyURL: latestSurveyURL,
            },
          })
        : null;
    } catch (error) {
      console.error("Unable to emit chat closed event.", error);
      return null;
    }
  })();

  if (
    !redirectUrl &&
    deliveryResult?.closeHandled !== true &&
    deliveryResult?.deferNativeClose !== true &&
    typeof closeNative === "function"
  ) {
    closeNative();
  }

  return deliveryResult;
};
